import { SEARCH_WATCHLIST, SEARCH_WATCHLIST_ERROR, SEARCH_WATCHLIST_HIDE_ERROR, SEARCH_WATCHLIST_START_LOADER, SEARCH_WATCHLIST_STOP_LOADER, } from "../interface/watchListSearch";
const initialState = {
    searchData: {
        searchList: [],
    },
    searchListLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const searchWatchlist = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_WATCHLIST:
            return Object.assign(Object.assign({}, state), { searchData: action.payload.searchList });
        case SEARCH_WATCHLIST_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SEARCH_WATCHLIST_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case SEARCH_WATCHLIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { searchListLoader: true });
        case SEARCH_WATCHLIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { searchListLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default searchWatchlist;
